import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { ES } from "@/i18n/es";

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (s) => s });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("artha-lang") || "en");

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const setLang = (l) => { localStorage.setItem("artha-lang", l); setLangState(l); };

  const t = useCallback((s, vars) => {
    let out = lang === "es" ? (ES[s] || s) : s;
    if (vars) Object.entries(vars).forEach(([k, v]) => { out = out.split(`{${k}}`).join(v); });
    return out;
  }, [lang]);

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
